import { usePermissions } from "react-admin";
import { checkPermission } from "./utils";
import { settings } from "app";

const SecuredComponent = ({ permission, tenancies, children }) => {
  const { permissions } = usePermissions();
  const tenanciesArray = tenancies ? (Array.isArray(tenancies) ? tenancies : [tenancies]) : null;

  if (tenanciesArray && !tenanciesArray.includes(settings.tenant)) {
    return null;
  }

  if (permission && !checkPermission(permissions, permission)) {
    return null;
  }

  return children;
};

export default SecuredComponent;
